import { useQuery, useQueryClient } from '@gogame/query';

import { loadAutoUpdateViaAPI } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';

import { autoUpdateViaAPI as key } from './queryKeyFactory';
import { useSocket } from '@gogame/sockets';
import { useCallback, useEffect } from 'react';
import { SOCKET_EVENT_API_PERMISSION_CHANGE } from '../constants';

export const useLoadAutoUpdateViaApi = () => {
  const query = useQuery(key, loadAutoUpdateViaAPI, {
    initialData: false,
  });
  const socket = useSocket();
  const queryClient = useQueryClient();

  const callback = useCallback(
    async (data) => {
      queryClient.setQueryData(key, () => data.value);
    },
    [queryClient]
  );

  useEffect(() => {
    socket.on(SOCKET_EVENT_API_PERMISSION_CHANGE, callback);
    return () => {
      socket.off(SOCKET_EVENT_API_PERMISSION_CHANGE, callback);
    };
  }, [socket, callback]);

  return query;
};
